import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { fadeInUp } from '../services/animations/fadeInUp.animation'
import { CheckEmail } from '../services/validators/check-email.validator'
import { ContactService } from '../services/contact.service'

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    animations: [fadeInUp]
})

export class ContactPageComponent implements OnInit {

    contactForm: FormGroup;
    errors: any = [];
    messages: any = [];
    contactType: string = 'general'

    technicalTypeOptions = [
        'Login',
        'Verifying Account',
        'Reset Password',
        'Sign Up',
        'Leave review',
        'Search',
        'Other'
    ]

    deviceTypeOptions = [
        'iOS',
        'Android',
        'Mac',
        'Windows',
        'Other'
    ]

    browserTypeOptions = [
        'Internet Explorer',
        'Edge',
        'Safari',
        'Opera',
        'Firefox',
        'Chrome',
        'Other'
    ]

    shouldDisplay: boolean = false

    constructor(
        private fbuilder: FormBuilder,
        private contactService: ContactService
    ) {
        this.contactForm = fbuilder.group({
            'name': [null, Validators.compose([Validators.required])],
            'technicalType': [null],
            'technicalTypeOther': [null],
            'deviceType': [null],
            'browserType': [null],
            'email': [null, Validators.compose([Validators.required, CheckEmail])],
            'message': [null, Validators.compose([Validators.required])],
            'reason': ['General enquiry']

            // 'name': [null],
            // 'email': [null],
            // 'message': [null],
            // 'reason': ['General enquiry']
        });
        this.formChanges()
    }

    ngOnInit() {
    }

    changeContactType(reason) {
        this.contactType = reason
        if (reason === 'technical') {
            this.contactForm.controls['technicalType'].setValidators([Validators.required])
            this.contactForm.controls['deviceType'].setValidators([Validators.required])
            this.contactForm.controls['browserType'].setValidators([Validators.required])
        } else {
            this.contactForm.controls['technicalType'].clearValidators()
            this.contactForm.controls['deviceType'].clearValidators()
            this.contactForm.controls['browserType'].clearValidators()
        }
        this.shouldDisplay = false
        this.contactForm.controls['technicalType'].updateValueAndValidity()
        this.contactForm.controls['deviceType'].updateValueAndValidity()
        this.contactForm.controls['browserType'].updateValueAndValidity()
    }

    technicalTypeChanged(event) {
        if (event.target.value === 'Other') {
            this.shouldDisplay = true
            this.contactForm.controls['technicalTypeOther'].setValidators([Validators.required])
        } else {
            this.shouldDisplay = false
            this.contactForm.controls['technicalTypeOther'].clearValidators()
        }
        this.contactForm.controls['technicalTypeOther'].updateValueAndValidity()
    }

    formChanges() {
        this.contactForm.valueChanges.subscribe(val => {
            this.errors = [];
            this.messages = [];
        });
    }

    submitContactForm(isValid: boolean, submission) {
        this.errors = []
        this.messages = []
        if (isValid) {
            this.contactService.contactForm(submission).then(result => {
                this.contactForm.reset()
                this.contactForm.controls['reason'].setValue('General enquiry')
                this.contactType = 'general'
                this.contactForm.controls['technicalTypeOther'].updateValueAndValidity()
                this.messages = [{ msg: 'Thank you for your message. It has been sent..' }]
            }).catch(error => {
                let err = error.json()
                this.errors = err
            })
        } else {
            this.errors = [{ msg: 'Please fill in all fields.' }]
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts